import { render, staticRenderFns } from "./UnitSelector.vue?vue&type=template&id=350a95de&"
import script from "./UnitSelector.vue?vue&type=script&lang=ts&"
export * from "./UnitSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports